import {WS_AUTHENTICATED, WS_CONNECTED, WS_CONNECTING, WS_DISCONNECTED, WS_MESSAGE, WS_RESET} from "./actionTypes";

export const wsConnecting = () => ({type: WS_CONNECTING});
export const wsConnected = () => ({type: WS_CONNECTED});
export const wsDisconnected = () => ({type: WS_DISCONNECTED});
export const wsMessage = (payload) => ({type: WS_MESSAGE, payload});
export const wsAuthenticated = () => ({type: WS_AUTHENTICATED});
export const resetWS = () => ({type: WS_RESET});

